import { render, staticRenderFns } from "./VentanaOperacionesLiquidacion.vue?vue&type=template&id=0d4fa57a"
import script from "./VentanaOperacionesLiquidacion.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesLiquidacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports